import styled from 'styled-components';
import { ISeparatorProps } from '../separator.types';
import { isVerticalOrientation } from '../utils';

export const FlexLine = styled.div.attrs({
    className: String('ap-separator')
}) <ISeparatorProps>`
    display: inline-flex;
    position: relative;
    width: ${({ orientation }) => (isVerticalOrientation(orientation!) ? '1px' : '100%')};
    height: ${({ orientation }) => (isVerticalOrientation(orientation!) ? '100%' : '1px')};
    background-color: ${({ color, theme: { semantics: { palette } } }) => color ?? palette.black};
    justify-content: ${({ orientation, beakPosition }) => (isVerticalOrientation(orientation!) ? 'unset' : beakPosition)};
    align-items: ${({ orientation, beakPosition }) => (isVerticalOrientation(orientation!) ? beakPosition : 'unset')};
`;
